<template>
	<el-dialog :close-on-click-modal="false"  :title="$t('model.editInfo')" :visible.sync="infoModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">

		<!-- 表單内容 -->
		<el-form :rules="info_rules" ref="form_info" :model="form_info" label-width="100px">
			<el-form-item :label="$t('model.head')">
			
				<el-upload
				  name="file"
				    class="avatar-uploader"
				    action="/admin/image/uploadNew"
				    :headers="{token:$store.state.user.token}"
				    :data="{type:'agHead'}"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="form_info.headUrl" :src="form_info.headUrl" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				
			</el-form-item>
			<el-form-item :label="$t('model.name')" prop="name">
				<el-input v-model="form_info.name" :placeholder="$t('model.name')" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item>
			
			<el-form-item :label="$t('model.username')" prop="username">
				<el-input v-model="form_info.username" :placeholder="$t('model.username')" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item>
			
			<el-form-item :label="$t('model.cms_name')" prop="cms_name">
				<el-input v-model="form_info.cms_name" placeholder="FF Cloud" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item>
			
			<el-form-item :label="$t('model.is_cms_logo')" prop="is_cms_logo">
				<el-switch
				  v-model="form_info.is_cms_logo"
				  active-color="#13ce66"
				  inactive-color="#999999">
				</el-switch>
			</el-form-item>
			
			
			
			
			<el-form-item :label="$t('model.cms_logo')">
			
				<el-upload
				  name="file"
				    class="avatar-uploader"
				    action="/admin/image/uploadNew"
				    :headers="{token:$store.state.user.token}"
				    :data="{type:'cmslogo'}"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess3"
				  :before-upload="beforeAvatarUpload">
				  <img :src="form_info.cms_logo?form_info.cms_logo:defaultLogo" class="avatar">
				 <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
				</el-upload>
				
			</el-form-item>
			
			<el-form-item :label="$t('model.tg_id')" prop="tg_id">
				<el-input v-model="form_info.tg_id" :placeholder="$t('model.tg_id')" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item>
			
			
			<el-form-item :label="$t('model.tg_qr')">
			
				<el-upload
				  name="file"
				    class="avatar-uploader"
				    action="/admin/image/uploadNew"
				    :headers="{token:$store.state.user.token}"
				    :data="{type:'agTg'}"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess2"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="form_info.tg_qr" :src="form_info.tg_qr" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				
			</el-form-item>
		
			<!-- <el-form-item label="排序">
		<el-input-number size="small" v-model="form.order" :min="0"></el-input-number>
	</el-form-item> -->
			
	
		</el-form>
	
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
			<el-button type="primary" @click="submitinfo">{{$t('model.success')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import defaultLogo from '@/assets/img/logo.png';
	import { commondecrypt } from '@/main';
	const user = JSON.parse(window.sessionStorage.getItem('user'))
	export default {
		inject: ['app'],
		props: {
			infoModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				defaultLogo,
				form_info:{
					headUrl:user.head?user.head:'',
					headId:0,
					name:user.name,
					username:user.username,
					is_cms_logo:user.is_cms_logo?1:0,
					cms_name:user.cms_name?user.cms_name:'',
					tg_id:user.tg_id,
					tg_qr:user.tg_qr?user.tg_qr:'',
					cms_logo:user.cms_logo?user.cms_logo:'',
				},
				info_rules: {
					name: [{
						required: true,
						message:  this.$t('model.inpName'),
						trigger: 'blur',
					}, ],
					username: [{
						required: true,
						message:  this.$t('model.inpUsername'),
						trigger: 'blur',
					}, ],
				
		
				},
			}
		},

		methods:{
			handleAvatarSuccess(res, file) {
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					console.log(res.encryption.data.list.url)
					this.form_info.headUrl = res.encryption.data.list.url
				}
			 },
			 
			 handleAvatarSuccess3(res, file) {
			 	let en_data = commondecrypt(res.encryption)
			 	res.encryption = JSON.parse(en_data)
			 	if(res.encryption.code==1){
			 					console.log(res.encryption.data.list.url)
			 		this.form_info.cms_logo = res.encryption.data.list.url
			 	}
			  },
			 
			 handleAvatarSuccess2(res, file) {
			 	let en_data = commondecrypt(res.encryption)
			 	res.encryption = JSON.parse(en_data)
			 	if(res.encryption.code==1){
					console.log(res.encryption.data.list.url)
			 		this.form_info.tg_qr = res.encryption.data.list.url
			 	}
			  },
		 beforeAvatarUpload(file) {
		 
		     const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
		     const isLt2M = file.size / 1024 / 1024 < 12;
		 
		     if (!isJPG) {
		     this.$message.error(this.$t('message.info_err'));
		     }
		     if (!isLt2M) {
		     this.$message.error(this.$t('message.img_max_err'));
		     }
		     return isJPG && isLt2M;
		 
		    },
			hide(){
				this.$emit('hide')
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form_info, 'headUrl', res[0].url);
					this.form_info['headId'] = res[0].id
					this.$set(this.form_info, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			//提交
			submitinfo() {
				this.$refs.form_info.validate(res => {
					if (res) {
						
						this.submitApi()
					}
				})
				
			},
			submitApi(){
				this.axios.post('/admin/user/editInfo', this.form_info, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						user.name = this.form_info.name
						user.head = this.form_info.headUrl
						user.tg_id = this.form_info.tg_id
						user.tg_qr = this.form_info.tg_qr
						user.cms_name = this.form_info.cms_name
						user.username = this.form_info.username
						user.cms_logo = this.form_info.cms_logo
						user.is_cms_logo = this.form_info.is_cms_logo
						window.sessionStorage.setItem('user',JSON.stringify(user))
						this.$message({
							message:  all.msg,
							type: 'success'
						});
						this.hide()
					}
				}).catch(err => {
					
				})
			}
			
		}
	}
</script>

<style>
</style>
